import PalletBuilderSuperStore from "../../stores/PalletBuilderSuperStore";

export const ManualPalletMachineConfig =
    {
        services: {
            loadPalletEventData: ctx => new PalletBuilderSuperStore().getPalletEventsData(ctx.palletData.stationId, ctx.hours, 500),
            savePallet: ctx => {
                debugger;
                ctx.palletData.jobs = ctx.selectedJobs;
                // So we can reuse another page, copy palletData to ctx.pallet
                ctx.pallet = ctx.palletData;

                // Have to remove the type attribute, it breaks the print flow
                delete ctx.pallet.type;

                return new PalletBuilderSuperStore().saveManualPallet(ctx.palletData)
            },
            printManifest: ctx => new PalletBuilderSuperStore().printManifest(ctx.pallet.id, ctx.printOptions.stationId, ctx.printOptions.saveDesignerData),
            generateDataSource: ctx => new PalletBuilderSuperStore().getPalletForReport(ctx.pallet.id),
        },
        actions: {
            logError: (context, event) => {
                console.error(event);
                context.error = event;
            },
        }
    }

export default ManualPalletMachineConfig;